import TextCell from 'components/TextCell';
import type { ManagedDepotsType } from '../..';

interface CellProps {
  rowData: ManagedDepotsType;
}

export default function AccountIdCell({
  rowData: { platformAccount },
}: CellProps) {
  return <TextCell text={platformAccount?.sourceId} />;
}
